import React, { createContext, useState, useContext, useEffect, useCallback, useMemo } from 'react';
import translations, { getTranslation } from '../utils/translations';

const LanguageContext = createContext();

const AVAILABLE_LANGUAGES = Object.keys(translations).map(code => ({
  code,
  nativeName: translations[code].nativeName,
  name: translations[code].name
}));

const getInitialLanguage = () => {
  try {
    return {
      ...translations.hi,
      code: 'hi'
    };
  } catch (error) {
    return {
      ...translations.en,
      code: 'en'
    };
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    try {
      localStorage.setItem('preferredLanguage', language.code);
    } catch (error) {
    }
  }, [language.code]);

  const handleLanguageChange = useCallback((newLang) => {
    try {
      if (!translations[newLang.code]) {
        throw new Error(`Invalid language code: ${newLang.code}`);
      }
      setLanguage({
        ...translations[newLang.code],
        code: newLang.code
      });
    } catch (error) {
    }
  }, []);

  const t = useCallback((key, params = {}) => {
    try {
      return getTranslation(language, key, params);
    } catch (error) {
      return key;
    }
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage: handleLanguageChange,
    translations,
    t,
    availableLanguages: AVAILABLE_LANGUAGES
  }), [language, handleLanguageChange, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
